import { render, staticRenderFns } from "./Solicitarsaque.vue?vue&type=template&id=2fc7b917&scoped=true"
import script from "./Solicitarsaque.vue?vue&type=script&lang=js"
export * from "./Solicitarsaque.vue?vue&type=script&lang=js"
import style0 from "./Solicitarsaque.vue?vue&type=style&index=0&id=2fc7b917&prod&lang=css"
import style1 from "./Solicitarsaque.vue?vue&type=style&index=1&id=2fc7b917&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7b917",
  null
  
)

export default component.exports